import { paths } from './paths'

// Fire-and-forget the same loader each route uses. The browser caches the dynamic
// import after the first call, and queryClient.prefetchQuery skips the network if
// data is already fresh — so hovering twice or hovering a cached route is free.
const fire = (
  importLoader: () => Promise<Record<string, () => unknown>>,
  key: string
) => {
  importLoader()
    .then((m) => (m[key] as () => void)())
    .catch(() => undefined)
}

export const routePrefetchers: Partial<Record<string, () => void>> = {
  [paths.home]: () =>
    fire(() => import('src/features/home/homeLoader'), 'homeLoader'),

  [paths.people.root]: () =>
    fire(
      () => import('src/features/people/loaders/peopleLoader'),
      'peopleLoader'
    ),

  [paths.people.directory]: () =>
    fire(
      () => import('src/features/people/loaders/peopleLoader'),
      'peopleLoader'
    ),

  [paths.people.orgStructure]: () =>
    fire(
      () => import('src/features/people/loaders/orgStructureLoader'),
      'orgStructureLoader'
    ),

  [paths.people.spotlights]: () =>
    fire(
      () => import('src/features/people/loaders/peopleSpotlightsLoader'),
      'peopleSpotlightsLoader'
    ),

  [paths.people.updates]: () =>
    fire(
      () => import('src/features/people-updates/peopleUpdatesLoader'),
      'peopleUpdatesLoader'
    ),

  [paths.news.root]: () =>
    fire(() => import('src/features/news/newsLoader'), 'newsLoader'),

  [paths.policies]: () =>
    fire(
      () => import('src/features/policies/policiesLoader'),
      'policiesLoader'
    ),

  [paths.benefits]: () =>
    fire(
      () => import('src/features/benefits/benefitsLoader'),
      'benefitsLoader'
    ),

  [paths.onBoarding.root]: () =>
    fire(
      () => import('src/features/onboarding/onBoardingLoader'),
      'onBoardingLoader'
    ),

  [paths.resources.root]: () =>
    fire(
      () => import('src/features/resources/resourcesLoader'),
      'resourcesLoader'
    )
}
